module.exports = __webpack_public_path__ + "img/0.07d7daa2.png";